import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Phone, Mail } from "lucide-react";
import { toast } from "sonner";
import { DISCLAIMER, subscribeNewsletter } from "../lib/api";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const res = await subscribeNewsletter(email);
      toast.success(res.message);
      setEmail("");
    } catch {
      toast.error("Please enter a valid email.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="relative bg-forest text-cream mt-32" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <h3 className="font-serif text-4xl md:text-5xl leading-none mb-5">
              Join the <span className="italic text-dusty-rose">ritual</span>.
            </h3>
            <p className="text-cream/70 mb-6 max-w-sm leading-relaxed">
              Slow mornings, quiet evenings, and small-batch blends. Subscribe for
              seasonal releases and herbal notes.
            </p>
            <form onSubmit={submit} className="flex gap-2 max-w-md" data-testid="newsletter-form">
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your@email.com"
                data-testid="newsletter-email"
                className="flex-1 bg-transparent border-b border-cream/30 py-3 px-1 text-cream placeholder-cream/40 focus:outline-none focus:border-dusty-rose"
                style={{ transition: "border-color 0.3s ease" }}
              />
              <button
                type="submit"
                disabled={loading}
                data-testid="newsletter-submit"
                className="rounded-full bg-terracotta hover:bg-dusty-rose text-cream hover:text-forest px-6 py-3 text-sm uppercase tracking-widest font-semibold disabled:opacity-60"
                style={{ transition: "background-color 0.3s ease, color 0.3s ease" }}
              >
                {loading ? "…" : "Subscribe"}
              </button>
            </form>
          </div>

          <div className="md:col-span-3 md:col-start-8">
            <p className="text-xs uppercase tracking-[0.2em] text-dusty-rose mb-5">Shop</p>
            <ul className="space-y-3 text-cream/80">
              <li><Link to="/shop" className="hover:text-dusty-rose" data-testid="footer-shop">All Teas</Link></li>
              <li><Link to="/shop?type=salve" className="hover:text-dusty-rose" data-testid="footer-salves">Salves</Link></li>
              <li><Link to="/shop?type=bundle" className="hover:text-dusty-rose" data-testid="footer-bundles">Bundles</Link></li>
              <li><Link to="/about" className="hover:text-dusty-rose" data-testid="footer-about">Our Story</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="text-xs uppercase tracking-[0.2em] text-dusty-rose mb-5">Contact</p>
            <ul className="space-y-3 text-cream/80 text-sm">
              <li className="flex items-center gap-2"><Phone className="w-4 h-4" /> (262) 945-6334</li>
              <li className="flex items-center gap-2"><Mail className="w-4 h-4" /> gingerroehl29@gmail.com</li>
            </ul>
            <div className="flex gap-4 mt-6">
              <a href="#" aria-label="Instagram" className="hover:text-dusty-rose" data-testid="social-instagram"><Instagram className="w-5 h-5" /></a>
              <a href="#" aria-label="Facebook" className="hover:text-dusty-rose" data-testid="social-facebook"><Facebook className="w-5 h-5" /></a>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-cream/15">
          <p className="text-[0.7rem] leading-relaxed text-cream/50 max-w-3xl" data-testid="footer-disclaimer">
            {DISCLAIMER}
          </p>
          <p className="text-xs text-cream/40 mt-6">
            © {new Date().getFullYear()} Serendipitous Sips &amp; Wellness · Racine, Wisconsin · Handcrafted in small batches.
          </p>
        </div>
      </div>
    </footer>
  );
}
